import { FirestoreDataConverter } from "firebase/firestore";
import { omit } from "lodash";
import Corretora from "../models/corretora";
import BaseDb from "./baseDb";

export default class CorretoraDb extends BaseDb<
  Corretora,
  { corretoraId: string }
> {
  _path: string = "corretoras/corretoraId";
  getConverter(): FirestoreDataConverter<Corretora> {
    return {
      fromFirestore: (snapshot, _options) => {
        return new Corretora({
          id: snapshot.id,
          apelido: snapshot.get("apelido"),
          avatar: snapshot.get("avatar"),
          nome: snapshot.get("nome"),
          cor: snapshot.get("cor"),
          passos: snapshot.get("passos"),
          leitorBMF: snapshot.get("leitorBMF"),
          leitorBovespa: snapshot.get("leitorBovespa"),
        });
      },
      toFirestore: (corretora: Corretora) => {
        return {
          ...omit(corretora, ["id"]),
        };
      },
    };
  }
}
